/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { GlobalContext } from 'providers/GlobalProvider';
import ContentLayout from 'components/Common/ContentLayout';
import GroupAPI from 'api/GroupAPI';
import { useSnackbar } from 'notistack';
import ActiveTeams from 'components/SuperAdmin/ActiveTeams';
// import ArchivedTeams from 'components/SuperAdmin/ArchivedTeams';

export interface IKeycloakTeam {
  id: string;
  name: string;
  path: string;
  subGroups: string[];
  realmRoles: string[];
  attributes?: Record<string, string[]>;
}

const TeamAccess: React.FC = () => {
  // eslint-disable-next-line
  const archivedID = process.env.REACT_APP_ARCHIVED_ID!;
  const { cur_user } = useContext(GlobalContext);
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [teams, setTeams] = useState<IKeycloakTeam[]>([]);

  const archiveTeam = async (teamId: string, teamName: string) => {
    const archivedTeamResp = await GroupAPI.addRoleToGroup(
      teamId,
      archivedID,
      'archived',
    );
    if (archivedTeamResp?.success) {
      enqueueSnackbar(`Successfully archived team ${teamName}`, {
        variant: 'success',
      });
      // refresh page so changes take place on UI
      history.go(0);
    } else {
      const err_text = `Error archiving team: ${archivedTeamResp?.result}`;
      enqueueSnackbar(err_text, { variant: 'error' });
    }
  };

  const getListOfGroupsAndFilter = async () => {
    const teamResp = await GroupAPI.getGroupsForAdmin();
    if (teamResp?.success) {
      setTeams(teamResp?.result);
    }
  };

  useEffect(() => {
    getListOfGroupsAndFilter();
  }, []);

  if (cur_user.bite_super_admin === false) {
    return <Redirect to='/' />;
  }
  return (
    <ContentLayout title='Team Access' compact>
      <ActiveTeams
        teams={teams}
        getGroups={getListOfGroupsAndFilter}
        archiveTeam={archiveTeam}
      />
    </ContentLayout>
  );
};

export default TeamAccess;
